export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "development",
  NEXT_PUBLIC_BASE_URL: "https://e2e-trmb-prod.netlify.app",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://e2e-trmb-prod.netlify.app",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "corporate",
  NEXT_PUBLIC_REDIRECT_NAME: "testing",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "f1e2584ztjpk",
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: "e2e-test",
  NEXT_PUBLIC_ONETRUST_ID: "019d30cc-4b48-709d-9d39-fdead8529a2f",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "prod_e2e_trmb",
  BYPASS_CONSENT_CHECK: true,
}
